import React from "react";
import Header from "../../../../../dev/terminal/containers/header";
import Popup from "../../../../../dev/terminal/containers/popup";
import Betslip from "../../../../../dev/terminal/components/betslip";
import ProfileHandler from "../../../../../dev/terminal/components/userProfileSubscriber";
import Loader from "../../../../../dev/terminal/components/loader";
import Config from "../../../../../dev/config/main";

export default function layoutTemplate () {
    let { location } = this.props,
        disabledHeader = location.pathname === "/admin",
        disabledBetslip = location.pathname === "/" || location.pathname === "/admin" || location.pathname === "/casino" || location.pathname === "/dealer" || location.pathname === "/casino/Favorites" || location.pathname === "/result";
    return (
        this.props.appReady // start rendering only when application is ready (translations/config/etc are loaded)
            ? <div className="terminal-wrapper asianBetslipStatic" onClick={this.handleClick}>
                {!disabledHeader ? <Header {...this.props}/> : null}
                <div className="content-wrapper-t">
                    <div className={`scroll-container-t ${Config.terminal.scrollButtons && "scroll-b-view"}`}>
                        {this.props.children}
                        {this.props.user && !this.props.user.loginInProgress && this.props.user.loggedIn ? <ProfileHandler /> : (null)}
                    </div>
                </div>
                <Betslip disableBetslip={!disabledBetslip}/>
                <Popup/>
            </div>
            : <Loader/>
    );
};